import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-lg font-semibold text-gray-900 mb-2 flex items-center" };
const _hoisted_2 = { class: "ml-auto flex items-center" };
const _hoisted_3 = { class: "space-y-2" };
const _hoisted_4 = { class: "flex items-center justify-between" };
const _hoisted_5 = { class: "flex items-center text-sm" };
const _hoisted_6 = { class: "font-medium text-gray-500" };
import { computed, ref, onMounted, onUnmounted } from "vue";
import { useCheckoutStore } from '@shared';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimeSelectionForm',
    props: {
        modelValue: {},
        orderType: {}
    },
    emits: ["open-modal", "update:model-value"],
    setup(__props) {
        const props = __props;
        // ✅ STORE-BASED: Verwende den checkout store
        const checkoutStore = useCheckoutStore();
        // Reactive current time
        const currentTime = ref(new Date());
        let timeUpdateInterval = null;
        // Update current time every minute
        onMounted(() => {
            timeUpdateInterval = setInterval(() => {
                currentTime.value = new Date();
            }, 60000); // Update every minute
            console.log("✅ [TimeSelection] Using checkout store for timing data");
        });
        onUnmounted(() => {
            if (timeUpdateInterval) {
                clearInterval(timeUpdateInterval);
            }
        });
        // ✅ STORE-BASED: Dynamic time display - ZENTRAL ÜBER STORE mit Order-Type spezifischen Zeiten
        const dynamicTimeDisplay = computed(() => {
            const currentOrderType = props.orderType;
            console.log("🔍 [TimeSelection] Store-based display computation:", {
                orderType: currentOrderType,
                modelValue: props.modelValue,
                hasPickupTime: !!props.modelValue.pickupTime,
                hasDeliveryTime: !!props.modelValue.deliveryTime,
                hasGenericTime: !!props.modelValue.time,
                storeSelectedPickupTime: checkoutStore.selectedPickupTime,
                storeSelectedDeliveryTime: checkoutStore.selectedDeliveryTime,
                storeLoading: checkoutStore.isLoading,
                currentTimeWindow: checkoutStore.currentTimeWindow,
                estimatedPickupTime: checkoutStore.estimatedPickupTime,
                estimatedDeliveryTime: checkoutStore.estimatedDeliveryTime,
            });
            // ✅ PRIORITÄT 1: Order-Type spezifische Zeiten aus Store (höchste Priorität)
            if (currentOrderType === "pickup" && checkoutStore.selectedPickupTime) {
                console.log("✅ [TimeSelection] Using store selected pickup time:", checkoutStore.selectedPickupTime);
                return `Heute um ${checkoutStore.selectedPickupTime} Uhr`;
            }
            if (currentOrderType === "delivery" && checkoutStore.selectedDeliveryTime) {
                console.log("✅ [TimeSelection] Using store selected delivery time:", checkoutStore.selectedDeliveryTime);
                return `Heute um ${checkoutStore.selectedDeliveryTime} Uhr`;
            }
            // ✅ PRIORITÄT 2: Legacy - Order-Type spezifische Zeiten aus modelValue
            if (currentOrderType === "pickup" && props.modelValue.pickupTime) {
                console.log("✅ [TimeSelection] Using modelValue pickup time:", props.modelValue.pickupTime);
                return `Heute um ${props.modelValue.pickupTime} Uhr`;
            }
            if (currentOrderType === "delivery" && props.modelValue.deliveryTime) {
                console.log("✅ [TimeSelection] Using modelValue delivery time:", props.modelValue.deliveryTime);
                return `Heute um ${props.modelValue.deliveryTime} Uhr`;
            }
            // ❌ ENTFERNT: Generische Zeit wird nicht mehr verwendet
            // Das verhindert, dass Pickup-Zeiten bei Delivery angezeigt werden
            // ✅ PRIORITÄT 3: Store-zentrale Zeitfenster-Berechnung für aktuellen Order Type
            const timeWindow = checkoutStore.currentTimeWindow;
            if (timeWindow && timeWindow.display) {
                console.log("✅ [TimeSelection] Using store calculated time window for", currentOrderType, ":", timeWindow.display, timeWindow);
                return `Heute ${timeWindow.display}`;
            }
            // ✅ PRIORITÄT 5: Loading state
            if (checkoutStore.isLoading) {
                console.log("🔄 [TimeSelection] Store is loading...");
                return "Wird berechnet...";
            }
            // ✅ PRIORITÄT 4: Fallback - manuelle Berechnung falls Store-API nicht funktioniert
            if (currentOrderType === "pickup" &&
                checkoutStore.estimatedPickupTime !== "Wird berechnet...") {
                const timeRangeMatch = checkoutStore.estimatedPickupTime.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
                if (timeRangeMatch) {
                    const endTime = timeRangeMatch[2]; // z.B. "20:33"
                    const now = currentTime.value;
                    const startTime = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
                    console.log("⚠️ [TimeSelection] Fallback: Manual pickup calculation:", `${startTime} - ${endTime}`);
                    return `Heute ${startTime} - ${endTime} Uhr`;
                }
            }
            if (currentOrderType === "delivery" &&
                checkoutStore.estimatedDeliveryTime !== "Wird berechnet...") {
                const timeRangeMatch = checkoutStore.estimatedDeliveryTime.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})/);
                if (timeRangeMatch) {
                    const endTime = timeRangeMatch[2]; // z.B. "21:53"
                    const now = currentTime.value;
                    const startTime = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
                    console.log("⚠️ [TimeSelection] Fallback: Manual delivery calculation:", `${startTime} - ${endTime}`);
                    return `Heute ${startTime} - ${endTime} Uhr`;
                }
            }
            // ✅ PRIORITÄT 5: Absoluter Fallback
            const now = currentTime.value;
            const bufferMinutes = currentOrderType === "pickup" ? 30 : 60;
            const fallbackTime = new Date(now.getTime() + bufferMinutes * 60 * 1000);
            const fallbackTimeStr = `${String(fallbackTime.getHours()).padStart(2, "0")}:${String(fallbackTime.getMinutes()).padStart(2, "0")}`;
            console.log("⚠️ [TimeSelection] Using absolute fallback time:", fallbackTimeStr);
            return `Heute um ${fallbackTimeStr} Uhr`;
        });
        const isComplete = computed(() => {
            return true;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "bg-white px-8 pt-2 pb-2 cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('open-modal')))
            }, [
                _createElementVNode("h3", _hoisted_1, [
                    _createTextVNode(_toDisplayString(_ctx.orderType === "pickup" ? "Abholzeit" : "Lieferzeit") + " ", 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_2, [
                        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-edit text-gray-400 text-sm mr-2" }, null, -1 /* CACHED */)),
                        _createElementVNode("div", {
                            class: _normalizeClass(['w-2 h-2 rounded-full', isComplete.value ? 'bg-green-500' : 'bg-gray-400'])
                        }, null, 2 /* CLASS */)
                    ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-clock mr-2 text-gray-500" }, null, -1 /* CACHED */)),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(dynamicTimeDisplay.value), 1 /* TEXT */)
                        ])
                    ])
                ])
            ]));
        };
    }
});
